import React from 'react';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { faFilters } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Input } from 'antd';
import { func } from 'prop-types';
import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';

function SearchAndFilters({ handleSearch, toggleFilterModal }) {
  return (
    <div className="arc-d-flex">
      <Input
        placeholder="Search mentors"
        prefix={<FontAwesomeIcon icon={faSearch} className="mr4" />}
        className="mentors-search"
        onChange={handleSearch}
        allowClear />
      <Button
        icon={<FontAwesomeIcon icon={faFilters} className="mr8" />}
        className="ml8 filter-mentors-btn"
        onClick={toggleFilterModal}>
        <I18nCustomFormatter id="filters-modal-title" />
      </Button>
    </div>
  );
}

SearchAndFilters.propTypes = {
  handleSearch: func.isRequired,
  toggleFilterModal: func.isRequired,
};

export default SearchAndFilters;
